import React from 'react';

const lerpColor = (a, b, t) => {
    return `rgb(
        ${Math.round(a[0] + (b[0] - a[0]) * t)},
        ${Math.round(a[1] + (b[1] - a[1]) * t)},
        ${Math.round(a[2] + (b[2] - a[2]) * t)}
    )`;
};

const FighterModifierScale = ({ value, max = 25, label = '', classLabel = '' }) => {
    return (
        <div className="fighterpage-modifier-outer">
            <div className="fighterpage-modifier-title">{label}</div>
            <div className="fighterpage-modifier-class">{classLabel}</div>
            <div className="fighterpage-modifier-scale">
                {[...Array(max)].map((_, i) => {
                    let t = i / (max - 1);
                    let color;
                    if (t < 0.5) {
                        color = lerpColor([220, 40, 40], [220, 220, 40], t * 2);
                    } else {
                        color = lerpColor([220, 220, 40], [50, 205, 50], (t - 0.5) * 2);
                    }
                    return (
                        <div
                            key={i}
                            className="fighterpage-modifier-bar"
                            style={{
                                background: i < value ? color : '#253654',
                                border: i < value ? '1px solid #d0e7ff22' : '1px solid #1e2b3e',
                                opacity: i < value ? 1 : 0.42
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default FighterModifierScale;
